/* eslint-disable @next/next/no-img-element */
import Link from "next/link"
import PropTypes from "prop-types"
import {
  DEFAULT_IMAGE_LINK,
  staticLabelsPLP,
} from "@/components/ProductListing/helper"
import SearchAccordion from "./SearchAccordion"
import SpecItems from "./SpecItems"
import Image from "next/legacy/image"
import { pdpImagesHandler } from "../detailsComponent/helper"
import React from "react"

export default function SpecCard({ productValueArray, locale = "en" }) {
  return (
    <>
      {productValueArray?.map(item => {
        const {
          sku_s,
          ProductProductNo_s,
          slug_s: slug = "",
          ProductDescriptionProductShort_s: productDescriptionProductShort,

          "ProductResource.DWGPlanView.resourceFullWebURL_ss": dwgPlanView = [],

          "ProductResource.3DDXFSymbol.resourceFullWebURL_ss":
            product3DDXFSymbol = [],

          "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss":
            productInstallationPDF = [],
          "ProductResource.SpecPDFFileName.resourceFullWebURL_ss":
            productSpecPDF = [],
          RegionBrandName_ss: regionBrandName = [],
          id = "",
        } = item || {}
        const images = pdpImagesHandler(item)
        return (
          <React.Fragment key={id}>
            <div className="relative overflow-x-hidden overflow-y-auto pb-[30px] mb-[30px] border-b border-gray-300 ">
              <div className="float-left p-[20px] bg-gradient-to-b from-gray-200 to-white bg-contain bg-no-repeat">
                <Image
                  src={images[0].src}
                  alt={images[0].alt}
                  height={125}
                  width={150}
                  onError={e =>
                    (e.target.src = images[0].fallBackSrc || DEFAULT_IMAGE_LINK)
                  }
                />
              </div>
              <Link
                href={`/product-details/${slug}?sku=${sku_s}`}
                as={`/product-details/${slug}?sku=${sku_s}`}
                className=""
                passHref
                legacyBehavior
              >
                <div className="w-[calc(100%-210px)] mb-[10px] ml-[-210px] float-right hover:cursor-pointer">
                  <span className="block mb-[3px] text-[12px] leading-[12px] font-[HelveticaRoman,_Helvetica,_sans-serif] font-[400] text-[#666]">
                    {ProductProductNo_s}
                  </span>
                  {productDescriptionProductShort ? (
                    <span className="display:block font-['Helvetica-Medium',_Helvetica,_sans-serif] text-[14px] text-[14px] leading-[1.25] text-[#337ab7] tracking-[0.50px] hover:text-[#23527c]">
                      {regionBrandName?.[0] || ""}{" "}
                      {productDescriptionProductShort}
                    </span>
                  ) : null}
                </div>
              </Link>
              {productSpecPDF.length || productInstallationPDF.length ? (
                <SearchAccordion header={staticLabelsPLP[locale].tech}>
                  <SpecItems
                    downloadLink={item}
                    linkType="technical"
                    locale={locale}
                  />
                </SearchAccordion>
              ) : null}
              {dwgPlanView.length || product3DDXFSymbol.length ? (
                <SearchAccordion header={staticLabelsPLP[locale].template}>
                  <SpecItems
                    downloadLink={item}
                    linkType="template"
                    locale={locale}
                  />
                </SearchAccordion>
              ) : null}
            </div>
          </React.Fragment>
        )
      })}
    </>
  )
}

SpecCard.propTypes = {
  productValueArray: PropTypes.arrayOf(
    PropTypes.shape({
      dwgPlanView: PropTypes.string,
      ThreeDDXF: PropTypes.string,
      SkuResourceImgName: PropTypes.string,
      ProductProductNo: PropTypes.string,
      sku_s: PropTypes.string,
      ProductDefaultSKU: PropTypes.string,
      ProductDescriptionProductShort: PropTypes.string,
      SpecPDFFileName: PropTypes.string,
      InstallationWithoutSPPDF: PropTypes.string,
      HomeguideWithSPPDF: PropTypes.string,
      HomeguideWithoutSPPDF: PropTypes.string,
    })
  ),
  locale: PropTypes.string,
}
